import { render, staticRenderFns } from "./InventoriesReadonly.vue?vue&type=template&id=86e769f2"
import script from "./InventoriesReadonly.vue?vue&type=script&lang=js"
export * from "./InventoriesReadonly.vue?vue&type=script&lang=js"
import style0 from "./InventoriesReadonly.vue?vue&type=style&index=0&id=86e769f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports